import React from 'react'
import NewRequest from './NewRequest'

export default function NewItemsRequestPage() {

    return <NewRequest />
}